import styled, { css } from 'styled-components';

import { TextWithLangLinks } from 'components/text-with-lang-links';

const textStyles = css`
  color: ${Styles.color.white};
  font-weight: ${Styles.fontWeight.heavy};
`;

const linkStyles = css`
  text-decoration: underline;
  cursor: pointer;
`;

export const CookieNoticeLink = styled.a`
  ${textStyles}
  ${linkStyles}
`;

export const StyledTextWithLangLinks = styled(TextWithLangLinks)`
  ${textStyles}
  a {
    ${textStyles}
    ${linkStyles}
  }
`;
